'use strict'

let stakeholderCommunicationFormDefinition=[
  {
    name: "stakeholder",
    fields: [
      { name: "name" },
      { name: "message", height: 3, optional:true }
    ]
  },
  {
    name: "information",
    fields: [
      { name: "requiredInformation", height: 3, optional:true },
      { name: "providedInformation", height: 3, optional:true }
    ]
  },
  {
    name: "communication",
    fields: [
      { name: "frequency", height:3,optional:true },
      { name: "means", optional:true },
      { name: "format", optional:true }
    ]
  }
]

export default [
  {
    name: "teamStructure",
    hideButtons: true
  },
  {
    name: "communicationManagementApproach",
    fields: [
      { name: "process", height: 5 },
      { name: "tools", height: 3 },
      { name: "reporting", height: 3 },
      { name: "timing", height: 2 },
      { name: "roles", height: 3 },
    ]
  },
  {
    name: "stakeholderAnalysis",
    hideButtons: true,
    fields: [
      {
        name: "stakeholders",
        type:"table",
        columns: [
          { name: "name" },
          { name: "message" },
          { name: "requiredInformation" },
          { name: "providedInformation" },
          { name: "frequency" }
        ],
        options: {
          addEntry: {
            formDefinition: stakeholderCommunicationFormDefinition
          },
          edit: {
            formDefinition: stakeholderCommunicationFormDefinition
          }
        }
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./views/organization/communicationManagementApproachFormDefinition.js